import * as ActionTypes from '../actions/ActionTypes';
import TranslateTemplateModalRecord from '../records/TranslateTemplateModalRecord';
const INITIAL_STATE = new TranslateTemplateModalRecord();
export default function translateTemplateModal(state = INITIAL_STATE, {
  type
}) {
  switch (type) {
    case ActionTypes.TEMPLATE_EDITOR_OPEN_TRANSLATE_TEMPLATE_MODAL:
      return state.set('modalOpen', true);
    case ActionTypes.TEMPLATE_EDITOR_CLOSE_TRANSLATE_TEMPLATE_MODAL:
      return state.set('modalOpen', false);
    default:
      return state;
  }
}